// extracted by mini-css-extract-plugin
module.exports = {"container":"ba","title":"bb","text":"bc"};